module.exports = __webpack_public_path__ + "img/3-4.89b608c2.svg";